import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import {
    EditedPhotoData,
    Photo,
    SelectedPhotoData
} from '@classifieds-sell/trademe-core-ui';
import { Subject } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-photo-section',
    templateUrl: './property-photo-section.component.html',
    styleUrls: ['./property-photo-section.component.scss'],
    standalone: false
})
export class PropertyPhotoSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    photos: Photo[] = [];

    @ViewChild('propertyPhotoSectionForm')
    propertyPhotoSectionForm: NgForm;

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.photos = this.draftData?.propertyPhotos?.photos || [];
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true; // TODO: add business rule validations
    }

    dirty(): boolean {
        if (this.photos.length === 0) {
            return true; // to update into db for listing with no photo
        }
        return this.propertyPhotoSectionForm.form.dirty;
    }

    onPhotoSelected(selectedPhotoData: SelectedPhotoData) {
        this.propertyPhotoSectionForm?.form.markAsDirty(); // required to be able to save draft data
        this.draftFacade.addPhotoToDraftData(
            { photoId: uuidv4(), loading: true, hasError: false } as Photo,
            selectedPhotoData,
            'propertyPhotos'
        );
    }

    onPhotosUpdated(photos: Photo[]) {
        this.propertyPhotoSectionForm?.form.markAsDirty(); // required to be able to save draft data
        this.draftFacade.updatePhotosInDraftData(photos, 'propertyPhotos');
    }

    onPhotoTransformed(editedPhotoData: EditedPhotoData) {
        this.propertyPhotoSectionForm?.form.markAsDirty(); // required to be able to save draft data
        this.draftFacade.updateTransformPhotoDataToDraftData(
            editedPhotoData,
            'propertyPhotos'
        );
    }
}
